/**
 * Pick the message out of a failed request. The server answers with different
 * shapes depending on where the error came from: a ValidationErrorResponse from
 * the validation filter, { message } from the authentication exception filter,
 * or a plain string from NotFound/Conflict.
 */
export function getServerErrorMessage(error: any): string | undefined {
  const data = error?.response?.data

  if (typeof data === 'string' && data.length > 0) {
    return data
  }

  return data?.errors?.[0]?.message ?? data?.message ?? undefined
}
